// extracted by css-extract-rspack-plugin
export default {"cls1":"OverlappingAvatars-cls1_UlB","cls2":"OverlappingAvatars-cls2_e-i OverlappingAvatars-cls1_UlB"};